enum EnquiryTypes {
  GetInTouch = 'Get in Touch',
  GotAnyQuestions = 'Got any Questions',
  LookingForASpecificCar = 'Looking for a specific car?',
  VehicleEnquiry = 'VehicleEnquiry',
}
export default EnquiryTypes;
